import React from 'react';
import {
  LegendCircle,
  LegendText,
  LegendWrapper
} from './BarGroupChart.styles';

const BarGroupChartLegend = ({ legend }) => {
  return legend.map((item, i) => (
    <LegendWrapper key={i}>
      <LegendCircle color={item.color}>&nbsp;</LegendCircle>
      <LegendText>{item.label}</LegendText>
    </LegendWrapper>
  ));
};

export default BarGroupChartLegend;
